export default "<p>enterprise works!</p>\n"